// ===== COLOR MADE - THEME JS =====

// Nav scroll
const nav = document.getElementById('nav');
const tomeHelper = document.getElementById('tome-helper');
const backToTop = document.getElementById('back-to-top');

if (tomeHelper) {
    tomeHelper.style.opacity = '0';
    tomeHelper.style.pointerEvents = 'none';
    tomeHelper.style.transition = 'opacity 0.4s ease, transform 0.4s ease';
}

let ticking = false;
window.addEventListener('scroll', () => {
    if (!ticking) {
        window.requestAnimationFrame(() => {
            const scrollY = window.scrollY;
            if (nav) nav.classList.toggle('scrolled', scrollY > 60);
            if (tomeHelper) {
                tomeHelper.style.opacity = scrollY > 400 ? '1' : '0';
                tomeHelper.style.pointerEvents = scrollY > 400 ? 'auto' : 'none';
            }
            if (backToTop) {
                backToTop.classList.toggle('visible', scrollY > 600);
            }
            ticking = false;
        });
        ticking = true;
    }
});

// Mobile nav
function toggleMobile() {
    const toggle = document.getElementById('nav-toggle');
    const links = document.getElementById('nav-links');
    const overlay = document.getElementById('nav-overlay');
    if (!toggle || !links || !overlay) return;
    toggle.classList.toggle('active');
    links.classList.toggle('open');
    overlay.classList.toggle('active');
    const isOpen = links.classList.contains('open');
    document.body.style.overflow = isOpen ? 'hidden' : '';
    toggle.setAttribute('aria-expanded', isOpen);
    toggle.setAttribute('aria-label', isOpen ? 'Fechar menu' : 'Abrir menu');
}

document.querySelectorAll('.nav-links a').forEach(l => l.addEventListener('click', () => {
    if (document.getElementById('nav-links').classList.contains('open')) toggleMobile();
}));

// Escape key closes mobile nav
document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && document.getElementById('nav-links') && document.getElementById('nav-links').classList.contains('open')) {
        toggleMobile();
    }
});

// Reveal on scroll
const revealObserver = new IntersectionObserver((entries) => {
    entries.forEach(e => {
        if (e.isIntersecting) {
            e.target.classList.add('visible');
            revealObserver.unobserve(e.target);
        }
    });
}, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });
document.querySelectorAll('.reveal').forEach(el => revealObserver.observe(el));

// Smooth scroll for anchor links
document.querySelectorAll('a[href^="#"]').forEach(a => {
    a.addEventListener('click', function(e) {
        const t = this.getAttribute('href');
        if (t && t !== '#' && t.length > 1) {
            const el = document.querySelector(t);
            if (el) {
                e.preventDefault();
                el.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
        }
    });
});

// Hero Carousel (used on homepage)
(function() {
    const slides = document.querySelectorAll('.hero-carousel .slide');
    const dots = document.querySelectorAll('.carousel-dot');
    const prevBtn = document.getElementById('carousel-prev');
    const nextBtn = document.getElementById('carousel-next');
    if (!slides.length || !prevBtn || !nextBtn) return;

    let current = 0;
    let autoplayTimer;

    function goTo(n) {
        slides[current].classList.remove('active');
        if (dots[current]) dots[current].classList.remove('active');
        current = (n + slides.length) % slides.length;
        slides[current].classList.add('active');
        if (dots[current]) dots[current].classList.add('active');
    }
    function next() { goTo(current + 1); }
    function prev() { goTo(current - 1); }
    function startAutoplay() { autoplayTimer = setInterval(next, 5000); }
    function resetAutoplay() { clearInterval(autoplayTimer); startAutoplay(); }

    prevBtn.addEventListener('click', () => { prev(); resetAutoplay(); });
    nextBtn.addEventListener('click', () => { next(); resetAutoplay(); });
    dots.forEach(d => d.addEventListener('click', () => { goTo(+d.dataset.slide); resetAutoplay(); }));
    startAutoplay();
})();

// Testimonials Carousel (used on homepage)
(function() {
    const track = document.getElementById('testemunhos-track');
    if (!track) return;
    const cards = track.querySelectorAll('.testemunho-card');
    const dots = document.querySelectorAll('.testemunho-dot');
    const prevBtn = document.getElementById('test-prev');
    const nextBtn = document.getElementById('test-next');
    if (!cards.length || !prevBtn || !nextBtn) return;

    let cur = 0;
    let autoTimer;

    function goTo(n) {
        if (dots[cur]) dots[cur].classList.remove('active');
        cur = (n + cards.length) % cards.length;
        track.style.transform = 'translateX(-' + (cur * 100) + '%)';
        if (dots[cur]) dots[cur].classList.add('active');
    }
    function next() { goTo(cur + 1); }
    function prev() { goTo(cur - 1); }
    function startAuto() { autoTimer = setInterval(next, 6000); }
    function resetAuto() { clearInterval(autoTimer); startAuto(); }

    prevBtn.addEventListener('click', () => { prev(); resetAuto(); });
    nextBtn.addEventListener('click', () => { next(); resetAuto(); });
    dots.forEach(d => d.addEventListener('click', () => { goTo(+d.dataset.test); resetAuto(); }));
    startAuto();
})();

// Instagram Carousel (infinite seamless loop)
(function() {
    var track = document.getElementById('insta-carousel-track');
    if (!track) return;
    var prevBtn = document.getElementById('insta-prev');
    var nextBtn = document.getElementById('insta-next');
    var originalItems = track.querySelectorAll('.insta-carousel-item');
    if (!originalItems.length) return;

    // Clone items for seamless infinite scroll
    var itemCount = originalItems.length;
    originalItems.forEach(function(item) {
        var clone = item.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        track.appendChild(clone);
    });
    // Also prepend clones for backwards scroll
    for (var i = itemCount - 1; i >= 0; i--) {
        var clone = originalItems[i].cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        track.insertBefore(clone, track.firstChild);
    }

    var allItems = track.querySelectorAll('.insta-carousel-item');
    var position = itemCount; // Start at first real item (after prepended clones)
    var isTransitioning = false;

    function getVisibleCount() {
        if (window.innerWidth <= 480) return 1;
        if (window.innerWidth <= 768) return 2;
        return 3;
    }

    function getMetrics() {
        var visible = getVisibleCount();
        var gap = 16;
        var itemWidth = (track.parentElement.clientWidth - (visible - 1) * gap) / visible;
        return { visible: visible, gap: gap, itemWidth: itemWidth };
    }

    function setPosition(animate) {
        var m = getMetrics();
        if (animate) {
            track.style.transition = 'transform 0.5s cubic-bezier(0.16, 1, 0.3, 1)';
        } else {
            track.style.transition = 'none';
        }
        track.style.transform = 'translateX(-' + (position * (m.itemWidth + m.gap)) + 'px)';
    }

    function goNext() {
        if (isTransitioning) return;
        isTransitioning = true;
        position++;
        setPosition(true);
    }

    function goPrev() {
        if (isTransitioning) return;
        isTransitioning = true;
        position--;
        setPosition(true);
    }

    // After transition ends, silently jump if we're in the clone zone
    track.addEventListener('transitionend', function() {
        isTransitioning = false;
        if (position >= itemCount * 2) {
            position = itemCount;
            setPosition(false);
        } else if (position < itemCount) {
            position = position + itemCount;
            setPosition(false);
        }
    });

    // Initial position (no animation)
    setPosition(false);

    if (prevBtn) prevBtn.addEventListener('click', goPrev);
    if (nextBtn) nextBtn.addEventListener('click', goNext);

    // Drag/swipe support
    var startX = 0, isDragging = false;
    track.addEventListener('mousedown', function(e) { startDrag(e.clientX); e.preventDefault(); });
    track.addEventListener('touchstart', function(e) { startDrag(e.touches[0].clientX); }, { passive: true });

    function startDrag(x) {
        isDragging = true;
        startX = x;
        track.classList.add('dragging');
    }

    window.addEventListener('mousemove', function(e) { if (isDragging) onDrag(e.clientX); });
    window.addEventListener('touchmove', function(e) { if (isDragging) onDrag(e.touches[0].clientX); }, { passive: true });

    function onDrag(x) {
        var diff = x - startX;
        var m = getMetrics();
        var base = position * (m.itemWidth + m.gap);
        track.style.transition = 'none';
        track.style.transform = 'translateX(' + (-base + diff) + 'px)';
    }

    window.addEventListener('mouseup', endDrag);
    window.addEventListener('touchend', endDrag);

    function endDrag(e) {
        if (!isDragging) return;
        isDragging = false;
        track.classList.remove('dragging');
        var endX = e.changedTouches ? e.changedTouches[0].clientX : e.clientX;
        var diff = endX - startX;
        if (diff < -50) goNext();
        else if (diff > 50) goPrev();
        else setPosition(true);
    }

    // Auto-scroll
    var autoTimer = setInterval(goNext, 4000);
    track.parentElement.addEventListener('mouseenter', function() { clearInterval(autoTimer); });
    track.parentElement.addEventListener('mouseleave', function() { autoTimer = setInterval(goNext, 4000); });

    window.addEventListener('resize', function() { setPosition(false); });
})();

// Intro overlay (homepage only)
(function() {
    const introOverlay = document.getElementById('intro-overlay');
    const introVideo = document.getElementById('intro-video');
    if (!introOverlay || !introVideo) return;

    let introSkipped = false;
    let introPlaying = false;

    window.playIntro = function() {
        if (introPlaying) return;
        introPlaying = true;
        introOverlay.classList.add('playing');
        introVideo.play().catch(function() {});
    };

    window.skipIntro = function() {
        if (introSkipped) return;
        introSkipped = true;
        introOverlay.classList.add('fade-out');
        document.body.style.overflow = '';
        setTimeout(() => { introOverlay.style.display = 'none'; introOverlay.remove(); }, 1000);
    };

    introVideo.addEventListener('ended', () => setTimeout(window.skipIntro, 300));
    introVideo.addEventListener('error', () => setTimeout(window.skipIntro, 500));
    setTimeout(() => { if (!introPlaying && !introSkipped) window.skipIntro(); }, 15000);
    document.body.style.overflow = 'hidden';

    // Auto-play: try to start the video automatically after a brief delay
    setTimeout(function() {
        if (!introPlaying && !introSkipped) {
            introPlaying = true;
            introOverlay.classList.add('playing');
            introVideo.play().catch(function() {
                // Autoplay blocked by browser - keep logo visible for user to click
                introPlaying = false;
                introOverlay.classList.remove('playing');
            });
        }
    }, 800);
})();

// Contact form handler
(function() {
    const form = document.getElementById('contact-form');
    if (!form) return;

    form.addEventListener('submit', function(e) {
        e.preventDefault();
        const btn = form.querySelector('.form-submit');
        const originalText = btn.innerHTML;
        btn.innerHTML = '<span>Mensagem enviada!</span> &#10003;';
        btn.style.background = 'var(--sage)';
        btn.style.pointerEvents = 'none';
        setTimeout(() => {
            btn.innerHTML = originalText;
            btn.style.background = '';
            btn.style.pointerEvents = '';
            form.reset();
        }, 3000);
    });
})();

// FAQ Accordion
(function() {
    var questions = document.querySelectorAll('.faq-question');
    if (!questions.length) return;

    questions.forEach(function(btn) {
        btn.addEventListener('click', function() {
            var item = btn.closest('.faq-item');
            var isOpen = item.classList.contains('open');

            // Close all
            document.querySelectorAll('.faq-item.open').forEach(function(el) {
                el.classList.remove('open');
                el.querySelector('.faq-question').setAttribute('aria-expanded', 'false');
            });

            // Toggle clicked
            if (!isOpen) {
                item.classList.add('open');
                btn.setAttribute('aria-expanded', 'true');
            }
        });
    });
})();

// Loja - Show/hide product categories
(function() {
    var buttons = document.querySelectorAll('.loja-banner-btn[data-show]');
    if (!buttons.length) return;

    var panels = document.querySelectorAll('.loja-products-panel');

    buttons.forEach(function(btn) {
        btn.addEventListener('click', function() {
            var target = btn.getAttribute('data-show');
            var panel = document.getElementById('panel-' + target);

            // Toggle: if clicking the same active button, hide panel and show banners
            if (btn.classList.contains('active-category')) {
                btn.classList.remove('active-category');
                panels.forEach(function(p) { p.style.display = 'none'; });
                return;
            }

            // Remove active from all buttons
            buttons.forEach(function(b) { b.classList.remove('active-category'); });
            btn.classList.add('active-category');

            // Hide all panels, show selected
            panels.forEach(function(p) { p.style.display = 'none'; });
            if (panel) {
                panel.style.display = '';
            }

            // Scroll to the panel
            if (panel) {
                setTimeout(function() {
                    panel.scrollIntoView({ behavior: 'smooth', block: 'start' });
                }, 100);
            }

            // Re-observe reveal elements in newly shown panel
            if (panel) {
                panel.querySelectorAll('.reveal:not(.visible)').forEach(function(el) {
                    revealObserver.observe(el);
                });
            }
        });
    });
})();

// Product variant selector (handled inline in main-product.liquid)
